import { render, staticRenderFns } from "./ContentTranslations.vue?vue&type=template&id=db1bbab8&"
import script from "./ContentTranslations.vue?vue&type=script&lang=js&"
export * from "./ContentTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports